import moment from 'moment';

export const coordinatoreInitialValues = {
  id: '',
  agenziekiron: [], // Array di ID
  attivo: false,
};

export const mapToCoordinatoreInitialValues = (newValues) => {
  const mappedValues = {
    id: newValues.id || '',
    agenziekiron: newValues._embedded.agenziekiron.map((ak) => ({
      value: ak.id,
      label: `${ak.codice} - ${ak.nome}`,
      key: ak.id,
    })),
    attivo: newValues.attivo ? '1' : '0',
    dataInizio: newValues.dataInizio ? moment.unix(newValues.dataInizio) : null,
    dataFine: newValues.dataFine ? moment.unix(newValues.dataFine) : null,
  };

  return mappedValues;
};

export const mapAgenziakironToinitialValues = (newValues) =>
  newValues._embedded.agenziakiron.map((ak) => ({
    value: ak.id,
    label: `${ak.codice} - ${ak.nome}`,
    key: ak.id,
  }));

export default coordinatoreInitialValues;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Coordinatore/initialValues.js